'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$19() {
  this.awE = null;
  this.awF = false;
}
export { $c_Lpresto_AgentView$$anon$19 as $c_Lpresto_AgentView$$anon$19 };
$p = $c_Lpresto_AgentView$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$19;
/** @constructor */
function $h_Lpresto_AgentView$$anon$19() {
}
export { $h_Lpresto_AgentView$$anon$19 as $h_Lpresto_AgentView$$anon$19 };
$h_Lpresto_AgentView$$anon$19.prototype = $p;
$p.P = (function() {
  if ((!this.awF)) {
    this.awE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.awF = true;
  }
  return this.awE;
});
var $d_Lpresto_AgentView$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$19, "presto.AgentView$$anon$19", ({
  DF: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$19 as $d_Lpresto_AgentView$$anon$19 };
//# sourceMappingURL=presto.-Agent-View$$anon$19.js.map
